import User from "@/assets/svg/user.svg";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/Avatar";

interface AccountAvatarProps {
  src?: string;
  width: string;
}

function AccountAvatar({ src, width }: AccountAvatarProps) {
  return (
    <Avatar css={{ width: width, height: width, mx: "auto" }}>
      <AvatarImage src={src} />
      <AvatarFallback>
        <User width={"calc(" + width + " * 0.75)"} stroke="white" />
      </AvatarFallback>
    </Avatar>
  );
}

export default AccountAvatar;
